import { AxiosInstance } from 'axios';
import { result, Result } from 'util/result';
import {
  ConfigurationResponse,
  ConfigurationsResponse,
} from 'data/terra/api/terra/response/ConfigurationResponse';
import Terra from '../Terra';
import { AppConfig, CreateAppConfigRequest } from 'data/terra/AppConfig';

class AppConfigEndpoint {
  getConfigsUrl = (appId: string, versionId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/apps/${appId}/versions/${versionId}/configs`;
  getConfigDetailUrl = (appId: string, versionId: string, configId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/apps/${appId}/versions/${versionId}/configs/${configId}`;
  getConfigActivateUrl = (appId: string, versionId: string, configId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/apps/${appId}/versions/${versionId}/configs/${configId}/activate`;
}


export class AppConfigApi {
  terraClient: AxiosInstance;
  endpoint = new AppConfigEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  fetchAppConfigs(
    appId: string,
    versionId: string
  ): Promise<Result<ConfigurationsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<ConfigurationsResponse>(
            this.endpoint.getConfigsUrl(appId, versionId)
          )
        ).data
    );
  }

  activateAppConfig(
    appId: string,
    versionId: string,
    configurationId: string
  ): Promise<Result<ConfigurationResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.put<ConfigurationResponse>(
            this.endpoint.getConfigActivateUrl(
              appId,
              versionId,
              configurationId
            ),
            { isActive: true }
          )
        ).data
    );
  }

  updateAppConfig(
    appId: string,
    versionId: string,
    configuration: AppConfig
  ): Promise<Result<ConfigurationResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.put<ConfigurationResponse>(
            this.endpoint.getConfigDetailUrl(
              appId,
              versionId,
              configuration.id
            ),
            { ...configuration }
          )
        ).data
    );
  }

  createAppConfig(
    appId: string,
    versionId: string,
    configDescription: CreateAppConfigRequest
  ): Promise<Result<ConfigurationResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<ConfigurationResponse>(
            this.endpoint.getConfigsUrl(appId, versionId),
            configDescription
          )
        ).data
    );
  }

  deleteVersionConfiguration(
    appId: string,
    versionId: string,
    configurationId: string
  ): Promise<Result<void>> {
    return result(async () => {
      await this.terraClient.delete<void>(
        this.endpoint.getConfigDetailUrl(appId, versionId, configurationId)
      );
    });
  }
}